import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.488.04A3.001 3.001 0 0 0 6.992 3v11.234l-2.43-1.458a2.946 2.946 0 0 0-3.599 4.61L7.577 24H20.85l1.7-11.051a4 4 0 0 0-3.115-4.52l-6.443-1.38V3.107c0-1.411-.965-2.816-2.503-3.066ZM8.99 3c0-.607.54-1.089 1.176-.985.429.07.825.511.825 1.092v5.559l8.023 1.72a2 2 0 0 1 1.558 2.259L19.133 22H8.406l-6.029-6.028a.946.946 0 0 1 1.156-1.48l5.458 3.274V3Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.26 3.36C21.84 1.656 20.01.823 18.578.414a11.26 11.26 0 0 0-1.811-.36A9.018 9.018 0 0 0 16.015 0h-.022s-.002 0-.002 1V0h-1v2h1.021a7.028 7.028 0 0 1 .53.04c.372.042.894.126 1.487.296 1.194.34 2.614 1.008 3.694 2.304l.64.768 1.537-1.28-.64-.769Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionDraw24 = createIcon(IconComponent);